import { InjectionToken } from '@angular/core';

export interface AppConfig {
  APIDomain: string;
  SSOApiBase: string;
  MyTaxAddress: string;
  refreshIntervalMs: number;
  clientId: string;
  redirectUri: string;
  authUrl: string;
  scope: string;
  tokenUrl: string;
  TaxPayerApiDomain: string; 
  beLoginUrl: string;
  YearBeStartOauth: number; 
  YearMtStartOauth: number;
  taefstream: string;
  // Add other config keys as needed
   features: {
    showEWHT: boolean;
    showEOT: boolean;
  };
  sectionTitles: {
    integrasiCkm: string; 
  };
}

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');